import { useQuery } from '@tanstack/react-query';
import { auditLogApi } from '../api/auditLogApi';
import type { AuditLogSearchCondition } from '../types/auditLog';

type MyParams = Omit<AuditLogSearchCondition, 'actor' | 'result' | 'severity' | 'resourceId' | 'traceId' | 'keyword'>;

/**
 * GET /api/eraf/audit-logs/me — 본인 활동 기록 (AUTHENTICATED)
 * queryKey: ['audit-log', 'me', filters]
 */
export function useMyAuditLog(filters: MyParams) {
  return useQuery({
    queryKey: ['audit-log', 'me', filters],
    queryFn: () => auditLogApi.me(filters),
    staleTime: 30_000,
  });
}
